import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';

import {
    ContactCardApulia, 
    ContactCardPorto, 
  } from "./common";

import styles from "../assets/styles/contactsModal.module.scss";
import addressBook from "../assets/images/address-book.svg";

interface IContactsModal{
    isHidden: boolean
}

export function ContactsModal(props: IContactsModal) {
    const { t, i18n } = useTranslation("contacts");

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  

    return <>
            <Button className={`${styles.contactsModalButton} d-flex align-items-center justify-content-center ${styles.visible} ${props.isHidden ? styles.invisible: ''}`} onClick={handleShow}>
                <img height={30} src={addressBook} alt={t("addressAlt")} />
            </Button>

            <Modal centered={true} show={show && !props.isHidden} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title style={{color: "rgb(74, 130, 120)"}}>{t("title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Carousel interval={null}>
                <Carousel.Item>
                    <div className="d-flex">
                        <ContactCardPorto iframeMinHeight="auto" addressAlt={t("address")} phoneAlt={t("phone")} />
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className="d-flex">
                        <ContactCardApulia iframeMinHeight="auto" addressAlt={t("address")} phoneAlt={t("phone")} />
                    </div>
                </Carousel.Item>
                </Carousel>
                </Modal.Body>
            </Modal>
        </>
   ;
}
